import React from 'react'
import {Route, Switch} from 'react-router-dom'
import Users from './Admin'
import Cupons from './Cupons/admin'
import CuponsVerified from './Cupons/verified'
import CuponsList from './Cupons/list'
import Store from './Store'
import Barchrt from './Reports/bar'
import ReportBalance from './Reports/balance'
import ReportBalanceCompany from './Reports/balanceCompany'
import Category from './Cupons/Category'
import Notifications from './Notifications'
import Products from './Products'
import Orders from './Orders'
import Notification from './Notification'

let urlRoutes = match => {
  if (localStorage.getItem('user_id') == 1) {
    return (
      <React.Fragment>
        <Route path={`/main/admin`} component={Users} />
        <Route path={`/main/products`} component={Products} />
        <Route path={`/main/orders`} component={Orders} />
        <Route path={`/main/notification`} component={Notification} />
        <Route path={`/main/store`} component={Store} />
        <Route path={`/main/coupons/admin`} component={Cupons} />
        <Route path={`/main/reports/category`} component={Barchrt} />
        <Route path={`/main/reports/inventory`} component={ReportBalance} />
        <Route
          path={`/main/reports/company`}
          component={ReportBalanceCompany}
        />
        <Route path={`/main/coupons/category`} component={Category} />
        <Route path={`/main/notifications`} component={Notifications} />
      </React.Fragment>
    )
  }
}

const Main = ({match}) => {
  return (
    <Switch>
      <Route
        path={`${match.url}/coupons/verified`}
        component={CuponsVerified}
      />
      <Route path={`${match.url}/coupons/list`} component={CuponsList} />
      {urlRoutes(match)}
    </Switch>
  )
}

export default Main



// WEBPACK FOOTER //
// ./src/routes/main/index.js